// importation des bibliothèques de modules node
import React, { useEffect, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

// importation du profil layout wrapper
import materielProfileLayout from './MaintenanceProfileLayout';

import MaintenanceService from '../../services/MaintenanceService';

const DeleteMaintenance = () => {
	const [maintenance, setMaintenance] = useState(null);
	const { id } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		Promise.all([MaintenanceService.getMaintenance(id)]).then(([maintenanceData]) => {
			setMaintenance(maintenanceData.data);
		});
	}, [id]);

	const handleSubmit = async (event) => {
		event.preventDefault();
		try {
			// Call the MaintenanceService to delete the Maintenance
			await MaintenanceService.deleteMaintenance(id);

			// Redirect the user to the list of Maintenances
			navigate('/services/maintenance');
		} catch (error) {
			console.error(
				"Erreur lors de la suppression de la Maintenance ",
				error
			);
		}
	};

	return (
		<materielProfileLayout>
			{maintenance && (
				<>
					{/*  Form  */}
					<Form className="mb-3" onSubmit={handleSubmit}>
						<Card className="border-0">
							<Card.Header>
								<div className="mb-3 mb-lg-0">
									<h3 className="mb-0">
										Supprimer{' '}
										<span className="text-uppercase">{maintenance.statut || ''}</span>
									</h3>
									<p className="mb-0">
										Supprimez définitivement cette Maintenance.
									</p>
								</div>
							</Card.Header>
							<Card.Body>
								<span className="text-danger h4">Attention</span>
								<p>
									Si vous supprimez cette maintenance, toutes les données le concernant seront
									définitivement perdues.
								</p>
								<Button variant="danger" type="submit">
									Supprimer la maintenance
								</Button>
							</Card.Body>
						</Card>
					</Form>
				</>
			)}
		</materielProfileLayout>
	);
};

export default DeleteMaintenance;
